<template>
  <div id="judges">
    <div class="con-center">
      <div class="title">
        <span>评委阵容</span>
      </div>

      <div class="judges-con">
        <div class="judges-con-list" v-for="(jud,index) in judgesCon">
          <div :class="'jud'+index"></div>
          <div>
            <p class="judges-name">{{ jud.name }}</p>
            <p class="judges-company">{{ jud.company }}</p>
            <p class="judges-company">{{ jud.position }}</p>
            <p class="judges-company">{{ jud.company2 }}</p>
            <p class="judges-company">{{ jud.position2 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Judges",
  data() {
    return{
      judgesCon: [
        { name: "刘平云", company: "广州美术学院视觉艺术设计", position: "学院副院长（主持工作）", company2: "北京冬奥会吉祥物“冰墩墩”", position2:"广美设计团队总执行"},
        { name: "王之纲", company: "清华大学美术学院信息艺术设计", position: "系主任 博士生导师", company2: "清华大学美术学院新媒体演艺创新", position2:"研究所 所长"},
        { name: "范冬明", company: "融创文化虚拟制作团队", position: "技术导演", company2: "", position2:""},
        { name: "温晓晖", company: "戴尔科技集团商用客户端", position: "产品及解决方案事业部 高级总监", company2: "", position2:""},
      ]
    }
  }
}
</script>

<style scoped lang="less">
#judges{
  position: relative;
  width: 100%;
  background: linear-gradient(
      148deg,
      #a1c4fd 0%,
      #c2e9fb 80%
  );
  .con-center{
    //max-width: 1160px;
    margin: 0 auto;
    position: relative;
    //padding: 0 10%;
    .title{
      position: absolute;
      content: '';
      width: 255px;
      height: 39px;
      top: -35px;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      justify-content: center;
      background: url("../assets/images/judges_title.png") no-repeat;
      background-size: 100% 100%;
      span{
        line-height: 82px;
        font-size: 25px;
        color: #14456e;
        font-weight: bold;
      }
      &:after{
        position: absolute;
        content: '';
        width: 249px;
        height: 75px;
        top: 6px;
        left: 2px;
        background: url("../assets/images/judges_title_bg.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .judges-con{
      display: flex;
      //flex-wrap: nowrap;
      justify-content: center;
      padding: 116px 0 120px;
      .judges-con-list{
        background: #14456e;
        margin-right: 30px;
        border-radius: 10px;
        text-align: center;
        color: #fff;
        .judges-name{
          font-size: 21px;
          font-weight: bold;
          padding: 6px 0;
        }
      }
    }
  }
}
@media (min-width: 992px){
  #judges{
    position: relative;
    width: 100%;
    background: linear-gradient(
        148deg,
        #a1c4fd 0%,
        #c2e9fb 80%
    );
    .con-center{
      //max-width: 1160px;
      margin: 0 auto;
      position: relative;
      padding: 0 10%;
      .title{
        position: absolute;
        content: '';
        width: 255px;
        height: 39px;
        top: -35px;
        left: 0;
        right: 0;
        margin: auto;
        display: flex;
        justify-content: center;
        background: url("../assets/images/judges_title.png") no-repeat;
        //background-size: 100% 100%;
        span{
          line-height: 82px;
          font-size: 25px;
          color: #14456e;
          font-weight: bold;
        }
        &:after{
          position: absolute;
          content: '';
          width: 249px;
          height: 75px;
          top: 6px;
          left: 2px;
          background: url("../assets/images/judges_title_bg.png") no-repeat;
          //background-size: 100% 100%;
        }
      }
      .judges-con{
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        padding: 116px 0 120px;
        .judges-con-list{
          width: 253px;
          height: 370px;
          background: #14456e;
          margin-right: 30px;
          border-radius: 10px;
          text-align: center;
          color: #fff;
          .jud0{
            width: 253px;
            height: 255px;
            background: url("../assets/images/judges1.jpg") no-repeat;
            background-size: cover;
            border-radius: 10px 10px 0 0 ;
          }
          .jud1{
            width: 253px;
            height: 255px;
            background: url("../assets/images/judges2.jpg") no-repeat;
            background-size: cover;
            border-radius: 10px 10px 0 0 ;
          }
          .jud2{
            width: 253px;
            height: 255px;
            background: url("../assets/images/judges3.jpg") no-repeat;
            background-size: cover;
            border-radius: 10px 10px 0 0 ;
          }
          .jud3{
            width: 253px;
            height: 255px;
            background: url("../assets/images/judges4.jpg") no-repeat;
            background-size: cover;
            border-radius: 10px 10px 0 0 ;
          }
          .judges-name{
            font-size: 21px;
            font-weight: bold;
            padding: 6px 0;
          }
          .judges-company{
            font-size: 12px;
          }
        }
      }
    }
  }
}
@media (max-width: 992px) {
  #judges{
    .con-center{
      .judges-con{
        flex-wrap: wrap;
        .judges-con-list{
            margin: 0 30px 20px;
            width: 287px;
            height: 430px;
          .jud0{
            width: 287px;
            height: 282px;
            background: url("../assets/images/judges1.jpg") no-repeat;
            background-size: cover;
            border-radius: 10px 10px 0 0 ;
          }
          .jud1{
            width: 287px;
            height: 282px;
            background: url("../assets/images/judges2.jpg") no-repeat;
            background-size: cover;
            border-radius: 10px 10px 0 0 ;
          }
          .jud2{
            width: 287px;
            height: 282px;
            background: url("../assets/images/judges3.jpg") no-repeat;
            background-size: cover;
            border-radius: 10px 10px 0 0 ;
          }
          .jud3{
            width: 287px;
            height: 282px;
            background: url("../assets/images/judges4.jpg") no-repeat;
            background-size: cover;
            border-radius: 10px 10px 0 0 ;
          }
          .judges-name{
            font-size: 21px;
            font-weight: bold;
            padding: 6px 0;
          }
          .judges-company{
            font-size: 15px;
          }
        }
      }
    }
  }
}
</style>